import type { TypePolicies } from '@apollo/client'
import { unionWith } from 'lodash'

import document_categories from './document_categories'
import miDocuments from './miDocuments'

export default {
  fields: {
    document_categories,
    miDocuments,
    risk_reports: {
      merge(existing = [], incoming) {

        if (incoming?.length) {
          return unionWith<{ __ref: string }>(existing, incoming, (a, b) => a.__ref === b.__ref)
        }


        return existing
      }
    },
  },
} as TypePolicies['Client']
